/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';

import { WindowHeight } from '../Fonctions';

import Dimensions from './Dimensions';
import Store from './Store';
import Couleur from './Couleur';
import Commande from './Commande';
import Orientation from './Orientation';
import Securite from './Securite';
import Environnement from './Environnement';
import Footer from './Footer';

function RightPanel({ isPortrait, HorsNormes, store_type, setStore, commande, setCommande, orientation, setOrientation, compas, setCompas, securite, setSecurite, largeur, setRangeLargeur, hauteur, setRangeHauteur, couleur, setCouleur, environnement, setEnvironnement, dimensions }) {
	const [height, setHeight] = useState();

	useEffect(() => {
		setHeight(WindowHeight(isPortrait, HorsNormes));
		window.addEventListener("resize", () => setHeight(WindowHeight(isPortrait), HorsNormes));
	}, [height, isPortrait, HorsNormes]);

	return (
		<div style={{ height: `${height}px`, overflowY: 'scroll', overflowX: 'hidden', marginTop: '4%' }}>
			<Stack gap={4}>

				{/* Choix du type de store */}
				<Store store_type={store_type} setStore={setStore}/>

				{/* Choix des dimensions */}
				<Dimensions
				dimensions={dimensions}
				largeur={largeur} setRangeLargeur={setRangeLargeur}
				hauteur={hauteur} setRangeHauteur={setRangeHauteur}
				store_type={store_type}
				/>

				{/* Choix de la couleur */}
				{store_type === 0 ?
				<Couleur couleur={couleur} setCouleur={setCouleur}/>
				: null}

				{/* Choix de la commande */}
				<Commande
				commande={commande}
				setCommande={setCommande}
				store_type={store_type}
				/>

				{/* Choix de l'orientation */}
				<Orientation
				orientation={orientation}
				setOrientation={setOrientation}
				compas={compas}
				setCompas={setCompas}
				/>

				{/* Choix de la sécurité */}
				<Securite securite={securite} setSecurite={setSecurite}/>

				{/* Choix de l'environnement */}
				<Environnement
				environnement={environnement}
				setEnvironnement={setEnvironnement}
				securite={securite}
				/>

				<Footer/>

			</Stack>
		</div>
	);
}

export default RightPanel;
